import { AxiosResponse } from "axios";
import { IOptions } from "../../api-sdk";
import BaseService from "../baseService";
import { IGetTvodStatusResponse } from "./tvod.content.types";

/**
 * Service for managing TVOD (Transactional Video on Demand) content.
 */
class TvodContentService extends BaseService {
  constructor(options: IOptions) {
    super(options);
  }

  /**
   * Synchronizes TVOD content for management.
   *
   * @param content_id The ID of the content to synchronize.
   * @returns A promise that resolves to the server's response containing a success message.
   */
  async syncTvodContent(
    content_id: string,
  ): Promise<AxiosResponse<{ message: string }>> {
    return this.request({
      method: "POST",
      url: `/api/v1/content/tvod/manage/${content_id}`,
    });
  }

  /**
   * Retrieves the TVOD status for a specific content.
   *
   * @param content_id The ID of the content to check the status for.
   * @returns A promise that resolves to the server's response containing the TVOD status.
   */
  async getTvodStatus(
    content_id: string,
  ): Promise<AxiosResponse<IGetTvodStatusResponse>> {
    return this.request({
      method: "GET",
      url: `/api/v1/content/tvod/status/${content_id}`,
    });
  }
}

export default TvodContentService;
